import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Container } from '@gik/ui';

const blockName = 'nav-bar';

export interface NavBarProps {
  className?: string;
  contained?: boolean;
  blurred?: boolean;
}

export default function NavBar({
  contained = false,
  blurred = false,
  children,
  className,
}: React.PropsWithChildren<NavBarProps>) {
  const bem = bemBlock(blockName);

  const Component = contained ? Container : 'div';

  return (
    <header className={bem(null, [{ blurred }], [className])}>
      <Component className={bem('container')}>{children}</Component>
    </header>
  );
}
